<div class="form-group flex-content" [hidden]="getHidden()" [id]="getId()">
  <label class="bs-h2 th-text-main" [class.col-sm-2]="getOneLineControl()">{{getTitle()}}</label>
  <label class="control-label">{{getLabelValue()}}</label>

  <div *ngIf="getOneLineControl()==true">
    <label class="i-checks" *ngFor="let item of this.data; let i=index">
      <input type="radio" #el="ngModel" [id]="getId() + i" [(ngModel)]="value" [name]="getName()+i + 1"
        [disabled]=item.status [value]=item.value style=" margin-right: 2px;">
      <i className="bs-label">{{item.label}}</i>
    </label>
  </div>
  <div *ngIf="getOneLineControl()==false" class="btn-group">
    <label class="i-checks" *ngFor="let item of this.data; let i=index">
      <input type="radio" #el="ngModel" [id]="getId() + i" [(ngModel)]="value" [name]="getName()+i + 1"
        [disabled]=item.status [value]=item.value style=" margin-right: 2px;">
      <i className="bs-label">{{item.label}}</i>
    </label>
  </div>
</div>